// react
import React from 'react'

// components
import Header from '_components/header/index.jsx'
import ListView from '_components/list-view/index.jsx'

class PixelClassesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div id="pixel-classes-page">
        <Header
          title="Pixel Classes"
          actions={[
            {
              children: 'Create New Pixel Class',
              onClick: this.toggleModal,
            },
          ]}
        />
        <ListView
          columns={[
            {
              key: 'name'
            },
            {
              key: 'batch_size'
            },
            {
              key: 'batch_period'
            }
          ]}
          entities="pixel-classes"
          fields={['name', 'batch_size', 'batch_period']}
          filters={[]}
          searchable={true}
          sort_key={'name'}
          sort_dir={1}
        />
      </div>
    )
  }
}

// export
export default PixelClassesPage
